<template lang="pug">
    div
        regular-button(@click="open" :value="BUTTONS_VALUES.add_recipient")
        modal(name="add-recipient" height="auto" :adaptive="true" :scrollable="true" classes="form-modal")
            .p-4.bg-gray-100
                    text-input(:label="FORMS_LABELS.phone" @value="phone = $event" :value="phone" v-mask="'+#(###) ###-##-##'")
                    
                    template(v-if="canPickGroup")
                        select-option.mt-3(
                            :label="FORMS_LABELS.user_group" 
                            name="group" 
                            :options="USER_GROUPS" 
                            @value="onGroup"
                        )

                    .mt-3
                        label.text-xs Акция
                        select.w-full.h-10.mt-1.pl-3.pr-3.border.rounded.border-slate-300.bg-white.text-xs(
                            v-model="promotionId"
                            :disabled="!stationGroup"
                        )
                            option(value="") {{ stationGroup ? 'выберите акцию' : 'сначала выберите станцию' }}
                            optgroup(v-if="sharedPromotions.length" label="Общие")
                                option(
                                    v-for="item in sharedPromotions"
                                    :key="item._id"
                                    :value="item._id"
                                    :style="item.active ? null : { color: '#ef4444' }"
                                ) {{ promotionLabel(item) }}
                            optgroup(v-if="stationPromotions.length" label="Станция")
                                option(
                                    v-for="item in stationPromotions"
                                    :key="item._id"
                                    :value="item._id"
                                    :style="item.active ? null : { color: '#ef4444' }"
                                ) {{ promotionLabel(item) }}

                    regular-button.w-200.mt-6(:value="BUTTONS_VALUES.add_recipient" :loading="adding" @click="onAdd")        
</template>

<script>
//Components
import TextInput from '@/components/common/forms/text-input';
import RegularButton from '@/components/common/buttons/regular-button';
import SelectOption from '@/components/common/forms/select-option';
//Config
import { FORMS_LABELS, BUTTONS_VALUES } from '@/configs/names';
import { ICONS } from '@/configs/icons';
import { USER_GROUPS } from '@/configs/user-groups';
//Store
import { RecipientsNameSpace, RecipientsActionTypes , RecipientsGetterTypes} from '@/store/recipients/types';
import { AuthorizationNameSpace, AuthorizationGetterTypes } from '@/store/authorization/types';
import { PromotionsNameSpace, PromotionsActionTypes } from '@/store/promotions/types';
//Mixins
import { _openModal_, _closeModal_ } from '@/mixins/modals';
//Helpers
import { notifyError } from '../../../helpers/notifications';

export default {
    name: "AddRecipientComponent",
    mixins: [_openModal_, _closeModal_],
    components: {
        'text-input': TextInput,
        'regular-button': RegularButton,
        'select-option': SelectOption,
    },
    data() {
        return {
            phone: '',
            group: null,
            promotionId: '',
            promotions: [],
            adding: false,
        }
    },
    computed: {
        FORMS_LABELS() {
            return FORMS_LABELS
        },
        BUTTONS_VALUES() {
            return BUTTONS_VALUES
        },
        ICONS() {
            return ICONS
        },
        USER_GROUPS() {
            return USER_GROUPS.filter(g => { return g.value !== 1 })
        },
        user_group() {
            return this.$store.getters[`${AuthorizationNameSpace}/${AuthorizationGetterTypes.GetGroup}`]
        },
        userRole() {
            return Number(this.$store.getters[`${AuthorizationNameSpace}/${AuthorizationGetterTypes.GetRole}`])
        },
        canPickGroup() {
            return this.userRole === 1 || this.userRole === 2 || this.userRole === 6
        },
        stationGroup() {
            return this.canPickGroup ? this.group : this.user_group
        },
        sharedPromotions() {
            return this.promotions.filter((item) => Number(item.group) === 0)
        },
        stationPromotions() {
            return this.promotions.filter((item) => Number(item.group) !== 0)
        },
        perPage() {
            return this.$store.getters[`${RecipientsNameSpace}/${RecipientsGetterTypes.GetPerPage}`]
        }, 
    },
    methods: {
        open() {
            this._openModal_({ name: 'add-recipient' })
            this.loadPromotions()
        },
        promotionLabel(item) {
            return item.active ? item.name : `${item.name} — Закончилась`
        },
        async loadPromotions() {
            this.promotionId = ''
            if (!this.stationGroup) {
                this.promotions = []
                return
            }
            const rows = []
            let page = 0
            let total = 0
            do {
                const body = await this.$store.dispatch(`${PromotionsNameSpace}/${PromotionsActionTypes.GetPromotions}`, {
                    params: { group: this.stationGroup, per_page: 100, page },
                })
                const chunk = (body && body.data && body.data.data) || []
                total = (body && body.data && body.data.total) || 0
                rows.push(...chunk)
                page += 1
                if (!chunk.length) {
                    break
                }
            } while (rows.length < total && page < 20)
            this.promotions = rows.slice().sort((left, right) => {
                if (left.active !== right.active) {
                    return left.active ? -1 : 1
                }
                return String(left.name).localeCompare(String(right.name), 'ru')
            })
        },
        async onAdd() {
            if (this.adding) {
                return
            }
            if (!this.promotionId) {
                notifyError({ title: 'Укажите акцию' })
                return
            }
            this.adding = true
            try {
                await this.$store.dispatch(`${RecipientsNameSpace}/${RecipientsActionTypes.AddRecipient}`, { data: {
                            phone: this.phone.replace(/\D+/g, ''),
                            group: this.stationGroup,
                            promotion: this.promotionId,
                        }
                    }
                )
                this.$store.dispatch(`${RecipientsNameSpace}/${RecipientsActionTypes.GetRecipients}`, {params: { per_page: this.perPage}})
                this.phone = ''
                this.promotionId = ''
                this._closeModal_({name: 'add-recipient'})
            } finally {
                this.adding = false
            }
        },
        onGroup(value) {
            const station = this.USER_GROUPS.find(r => r.name === value)
            this.group = station ? station.value : null
            this.loadPromotions()
        }
    }
}
</script>